import $ from 'domtastic'


// Views
import BaseView from './views/_BaseView'
import Home from './views/Home'


const viewsMap = {
    Base : BaseView,
    home : Home,
}




/* ROUTER
----------------------------------------------------------------------------------------------------*/

export default class Router {

    constructor() {
        this.$els = {
            body     : $('body'),
            router   : $('.router'),
            navItems : $('.nav__item'),
        }


        this.views = {}


        this.transitioning = true
        this.pageTitle     = document.title
        this.slug          = document.location.pathname + document.location.search
        this.view          = this.$els.body.attr('data-v')
        this.same          = false


        // Kickstart navigation
        this.bindEvents()
        this.startNav() // Comment this line to remove dynamic nav
    }




    /* Navigation & Routing
    ---------------------------------------------------------*/

    bindEvents() {
        $(window).on('load', () => { this.onPageLoad(true) })
    }


    startNav() {
        // Avoid automatic scrolltop on popstate
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual'
        }


        // Intercept internal links clicks
        $(document).on('click', 'a', (e) => { this.onLinkClick(e) })


        // Intercept popstate
        window.onpopstate = (e) => { this.onPopState(e) }


        window.history.pushState({ view: this.view, slug: this.slug }, '', this.slug)
    }




    /* Handlers
    --------------------------------------------------------- */

    onPageLoad(firstLoad) {
        this.initPage(this.view)

        if (firstLoad) {
            this.transitioning = false
            $('body').removeClass('transitioning')
        }
    }


    onLinkClick(e) {
        const $this = $(e.target)
        const href  = $this.attr('href')

        // Cancel if special link
        if ($this.attr('target') === '_blank'
            || href.indexOf('mailto:') >= 0
            || href.indexOf('tel:') >= 0
            || href.indexOf('#') === 0) return


        // Cancel if special user behavior
        if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return


        e.preventDefault()
        if (APP.Layout.dragging) return


        const slug = href

        setTimeout(() => this.goto(null, slug, true), 0)
    }


    onPopState(e) {
        if (e.state === null) return

        const { view } = e.state
        const { slug } = e.state

        this.goto(view, slug, false, e.state, true)
    }




    /* Actions
    ---------------------------------------------------------*/

    goto(v, slug, pushState, state = {}, popping = false) {
        if (slug === this.slug || this.transitioning) return

        const view = v


        // Turn transition on
        this.transitioning = true
        $('body').addClass('transitioning')
        $(document).trigger('pageWillChange', state)


        // Load new page
        this.loadPage(view, slug, pushState, state, popping)
    }


    loadPage(view, slug, pushState, state, popping) {
        this.prevView      = this.view
        this.prevPageTitle = this.pageTitle


        // Get new content
        fetch(slug, fetchOptions)
            .then(response => (
                response.text()
            ))
            .then((html) => {
                this.prepareNewPage(view, slug, html, pushState, state, popping)

                // Track
                track(slug)
            })
    }


    prepareNewPage(v, slug, html, pushState, state, popping) {
        const $content    = $('<html>')
        const newCtnClass = '| is-coming is-above'

        $content.html(html)

        // Prepare old container
        this.$oldCtn = $('.view')
        this.$oldCtn[0].style.top = `-${window.pageYOffset}px`
        this.$oldCtn.addClass('| is-going')
        this.avoidMobileJump()


        // Change page title & view
        const view  = v || $content.find('body').attr('data-v')
        const title = $content.find('title').text()

        $('body').attr('data-v', view)
        document.title = title
        this.pageTitle = title


        // Set nav data
        this.view = view
        this.slug = slug
        this.same = this.view === this.prevView


        // Get new page content
        this.$newCtn = $(`<div class="view view--${view} ${newCtnClass}">`)
        this.$newCtn.html($content.find('.view').html())


        // Replace page content
        this.$els.router.append(this.$newCtn)


        // Update nav current style
        this.updateNav($content)


        if (pushState) {
            // Populate state
            state.view     = view
            state.popping  = popping
            state.prevView = this.prevView

            const s = { view: this.view, slug: this.slug }

            window.history.pushState(s, '', slug)
        }


        // End transition
        const delay = getTransitionDelay(view, this.prevView)
        setTimeout(() => { this.endTransition(0, 800) }, delay)
    }


    endTransition(classDelay = 0, removeDelay = 0) {
        setTimeout(() => {
            this.$newCtn.removeClass('| is-coming is-same is-beneath')

            setTimeout(() => {
                this.onPageLoad()
                $(document).trigger('pageChangeEnd')
            }, 32)
        }, classDelay)


        setTimeout(() => {
            this.$oldCtn.remove()
            this.stopMobileJumpAvoidance()

            this.transitioning = false
            $('body').removeClass('transitioning')
        }, removeDelay)
    }


    initPage(view) {
        Object.entries(this.views).forEach((v) => {
            v[1].destroy()
            delete this.views[v[0]]
        })

        this.views[view] = (viewsMap[view]) ? new viewsMap[view]() : new viewsMap.Base({ namespace: `.${view}` })
    }


    updateNav($ctn) {
        const $navItems = $ctn.find('.nav__item')
        const $currItem = $ctn.find('.nav__item.is-current')
        const navIndex  = $navItems.indexOf($currItem[0])

        this.$els.navItems.removeClass('| is-current')

        if (navIndex > -1) {
            const $currEl = $(this.$els.navItems.get(navIndex))
            $currEl.addClass('| is-current')
        }
    }


    avoidMobileJump() {
        if (!APP.Layout.isMobile) return

        const contentHeight = APP.Layout.docHeight

        this.$els.router.css('height', `${contentHeight}px`)

        window.scrollTo(0, 0)
    }


    stopMobileJumpAvoidance() {
        if (!APP.Layout.isMobile) return

        setTimeout(() => {
            this.$els.router.css('height', '')
        }, 16)
    }




    /* Values
    ---------------------------------------------------------*/

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */

const h = new Headers()
h.append('X-Requested-With', 'XMLHttpRequest')

const fetchOptions = {
    headers     : h,
    credentials : 'same-origin',
}


const getTransitionDelay = (view, prevView) => {
    let delay = 0

    switch (view) {
        default: delay = 0; break
    }


    return delay
}

// @TODO: use gtag instead
const track = (slug) => {
    if (typeof ga !== 'undefined') {
        ga('send', 'pageview', slug)
    }
}



